export const PAGE_REFERRER_STORAGE_KEY = 'referrer';
